export default {
	api: '',
	loginTimeout: 18000000
};
